// extracted by mini-css-extract-plugin
module.exports = {"label":"Dropdown_label__1M_Gm","subtext":"Dropdown_subtext__3s3d1","errors":"Dropdown_errors__11Oi5"};